/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Customer_ListInputs */

const vi_nav_customer_list = /** @type {(inputs: Nav_Customer_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách`)
};

/**

* @param {Nav_Customer_ListInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_customer_list = /** @type {((inputs?: Nav_Customer_ListInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Customer_ListInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_customer_list(inputs)
});